/**
 * German federal states (Bundesländer).
 * Codes mirror the backend's `src/utils/location/germanStates.js` — keep in sync.
 */

export const GERMAN_STATES = [
	{ code: 'BW', label: 'Baden-Württemberg' },
	{ code: 'BY', label: 'Bayern' },
	{ code: 'BE', label: 'Berlin' },
	{ code: 'BB', label: 'Brandenburg' },
	{ code: 'HB', label: 'Bremen' },
	{ code: 'HH', label: 'Hamburg' },
	{ code: 'HE', label: 'Hessen' },
	{ code: 'MV', label: 'Mecklenburg-Vorpommern' },
	{ code: 'NI', label: 'Niedersachsen' },
	{ code: 'NW', label: 'Nordrhein-Westfalen' },
	{ code: 'RP', label: 'Rheinland-Pfalz' },
	{ code: 'SL', label: 'Saarland' },
	{ code: 'SN', label: 'Sachsen' },
	{ code: 'ST', label: 'Sachsen-Anhalt' },
	{ code: 'SH', label: 'Schleswig-Holstein' },
	{ code: 'TH', label: 'Thüringen' },
];

export const GERMAN_STATE_LABELS = Object.fromEntries(GERMAN_STATES.map((s) => [s.code, s.label]));
